export var DatePickerStyles = function () {
    return {
        wrapper: {
            ".MuiInputBase-input": { height: "14px" },
        },
    };
};
